import {combineReducers} from 'redux'
import {reducer as reduxFormReducer} from 'redux-form'
import {tokenReducer} from './Token'
import {articleDataReducer} from './ArticleData'
import {uiReducer} from './UserInterface'
import {appStateReducer} from './AppState'
import {toggleSelectionReducer} from './ToggleSelections'
import * as storage from 'redux-storage'


// **************************************************************************************************************
const rootReducer = combineReducers({
    token: tokenReducer,
    articleData: articleDataReducer,
    ui: uiReducer,
    appState: appStateReducer,
    form: reduxFormReducer,
    toggleSelections: toggleSelectionReducer,
})

export default storage.reducer(rootReducer)


/** WEBPACK FOOTER **
 ** ./src/reducers/index.configurator.js
 **/